import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { setActiveModule } from '../../../../../../../../services/routing/actions'

function mapStateToProps(state, hocProps) {
    const type = _.get(hocProps, 'type', '')

    return {
        active: state.getIn(['ui', 'moduleMenu', 'active']) === type,
        locale: state.getIn(['translate', 'locale']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ setActiveModule }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
